import { render, staticRenderFns } from "./AscentGymBulkForm.vue?vue&type=template&id=897115ea"
import script from "./AscentGymBulkForm.vue?vue&type=script&lang=js"
export * from "./AscentGymBulkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports